(() => {
  let cleanup = () => {};
  const init = () => {
    cleanup();
    const frame = document.querySelector('[data-jk-studio-film]');
    const template = frame?.querySelector('[data-jk-studio-template]');
    const button = frame?.querySelector('[data-jk-studio-motion]');
    if (!template || !button) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduce.matches || Boolean(navigator.connection?.saveData);
    let visible = false;
    let video;
    const label = () => {
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('[data-jk-studio-motion-label]').textContent = paused ? button.dataset.resume : button.dataset.pause;
      button.querySelector('[data-jk-studio-motion-icon]').textContent = paused ? '▶' : 'Ⅱ';
    };
    const play = () => {
      if (paused || !visible || document.hidden) { video?.pause(); return; }
      if (!video) {
        video = template.content.querySelector('video').cloneNode(true);
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.addEventListener('playing', () => {
          if (paused || !visible || document.hidden) video.pause();
          else video.classList.add('is-ready');
        }, options);
        frame.append(video);
      }
      video.play().catch(() => {
        if (controller.signal.aborted || paused || !visible || document.hidden) return;
        paused = true;
        label();
      });
    };
    button.hidden = false;
    button.addEventListener('click', () => { paused = !paused; label(); play(); }, options);
    reduce.addEventListener('change', () => { paused = reduce.matches; label(); play(); }, options);
    document.addEventListener('visibilitychange', play, options);
    let observer;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; play(); }, { threshold: 0.05 });
      observer.observe(frame);
    } else { visible = true; play(); }
    label();
    cleanup = () => { controller.abort(); observer?.disconnect(); video?.pause(); video?.remove(); };
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
